import styled from 'styled-components/macro'

const Wrapper = styled('div')`
  height: 42px;
  display: flex;
  align-items: center;
  float: right;
`

export default Wrapper
